const textDecorationColor = {
    name: "text-decoration-color",
    path: "/text-decoration-color",
    title: "text-decoration-color",
    description: "Utilities for controlling the color of text decoration lines.",
    value: {
        "text-decoration-color": {
            "decoration-color-inherit": "inherit",
            "decoration-color-current": "currentColor",
            "decoration-color-transparent": "transparent",
            "decoration-color-black": "var(--color-black)",
            "decoration-color-white": "var(--color-white)",
            "decoration-color-red-50": "var(--color-red-50)",
            "decoration-color-red-100": "var(--color-red-100)",
            "decoration-color-red-200": "var(--color-red-200)",
            "decoration-color-red-300": "var(--color-red-300)",
            "decoration-color-red-400": "var(--color-red-400)",
            "decoration-color-red-500": "var(--color-red-500)",
            "decoration-color-red-600": "var(--color-red-600)",
            "decoration-color-red-700": "var(--color-red-700)",
            "decoration-color-red-800": "var(--color-red-800)",
            "decoration-color-red-900": "var(--color-red-900)",
            "decoration-color-orange-50": "var(--color-orange-50)",
            "decoration-color-orange-100": "var(--color-orange-100)",
            "decoration-color-orange-200": "var(--color-orange-200)",
            "decoration-color-orange-300": "var(--color-orange-300)",
            "decoration-color-orange-400": "var(--color-orange-400)",
            "decoration-color-orange-500": "var(--color-orange-500)",
            "decoration-color-orange-600": "var(--color-orange-600)",
            "decoration-color-orange-700": "var(--color-orange-700)",
            "decoration-color-orange-800": "var(--color-orange-800)",
            "decoration-color-orange-900": "var(--color-orange-900)",
            "decoration-color-amber-50": "var(--color-amber-50)",
            "decoration-color-amber-100": "var(--color-amber-100)",
            "decoration-color-amber-200": "var(--color-amber-200)",
            "decoration-color-amber-300": "var(--color-amber-300)",
            "decoration-color-amber-400": "var(--color-amber-400)",
            "decoration-color-amber-500": "var(--color-amber-500)",
            "decoration-color-amber-600": "var(--color-amber-600)",
            "decoration-color-amber-700": "var(--color-amber-700)",
            "decoration-color-amber-800": "var(--color-amber-800)",
            "decoration-color-amber-900": "var(--color-amber-900)",
            "decoration-color-yellow-50": "var(--color-yellow-50)",
            "decoration-color-yellow-100": "var(--color-yellow-100)",
            "decoration-color-yellow-200": "var(--color-yellow-200)",
            "decoration-color-yellow-300": "var(--color-yellow-300)",
            "decoration-color-yellow-400": "var(--color-yellow-400)",
            "decoration-color-yellow-500": "var(--color-yellow-500)",
            "decoration-color-yellow-600": "var(--color-yellow-600)",
            "decoration-color-yellow-700": "var(--color-yellow-700)",
            "decoration-color-yellow-800": "var(--color-yellow-800)",
            "decoration-color-yellow-900": "var(--color-yellow-900)",
            "decoration-color-lime-50": "var(--color-lime-50)",
            "decoration-color-lime-100": "var(--color-lime-100)",
            "decoration-color-lime-200": "var(--color-lime-200)",
            "decoration-color-lime-300": "var(--color-lime-300)",
            "decoration-color-lime-400": "var(--color-lime-400)",
            "decoration-color-lime-500": "var(--color-lime-500)",
            "decoration-color-lime-600": "var(--color-lime-600)",
            "decoration-color-lime-700": "var(--color-lime-700)",
            "decoration-color-lime-800": "var(--color-lime-800)",
            "decoration-color-lime-900": "var(--color-lime-900)",
            "decoration-color-green-50": "var(--color-green-50)",
            "decoration-color-green-100": "var(--color-green-100)",
            "decoration-color-green-200": "var(--color-green-200)",
            "decoration-color-green-300": "var(--color-green-300)",
            "decoration-color-green-400": "var(--color-green-400)",
            "decoration-color-green-500": "var(--color-green-500)",
            "decoration-color-green-600": "var(--color-green-600)",
            "decoration-color-green-700": "var(--color-green-700)",
            "decoration-color-green-800": "var(--color-green-800)",
            "decoration-color-green-900": "var(--color-green-900)",
            "decoration-color-emerald-50": "var(--color-emerald-50)",
            "decoration-color-emerald-100": "var(--color-emerald-100)",
            "decoration-color-emerald-200": "var(--color-emerald-200)",
            "decoration-color-emerald-300": "var(--color-emerald-300)",
            "decoration-color-emerald-400": "var(--color-emerald-400)",
            "decoration-color-emerald-500": "var(--color-emerald-500)",
            "decoration-color-emerald-600": "var(--color-emerald-600)",
            "decoration-color-emerald-700": "var(--color-emerald-700)",
            "decoration-color-emerald-800": "var(--color-emerald-800)",
            "decoration-color-emerald-900": "var(--color-emerald-900)",
            "decoration-color-teal-50": "var(--color-teal-50)",
            "decoration-color-teal-100": "var(--color-teal-100)",
            "decoration-color-teal-200": "var(--color-teal-200)",
            "decoration-color-teal-300": "var(--color-teal-300)",
            "decoration-color-teal-400": "var(--color-teal-400)",
            "decoration-color-teal-500": "var(--color-teal-500)",
            "decoration-color-teal-600": "var(--color-teal-600)",
            "decoration-color-teal-700": "var(--color-teal-700)",
            "decoration-color-teal-800": "var(--color-teal-800)",
            "decoration-color-teal-900": "var(--color-teal-900)",
            "decoration-color-cyan-50": "var(--color-cyan-50)",
            "decoration-color-cyan-100": "var(--color-cyan-100)",
            "decoration-color-cyan-200": "var(--color-cyan-200)",
            "decoration-color-cyan-300": "var(--color-cyan-300)",
            "decoration-color-cyan-400": "var(--color-cyan-400)",
            "decoration-color-cyan-500": "var(--color-cyan-500)",
            "decoration-color-cyan-600": "var(--color-cyan-600)",
            "decoration-color-cyan-700": "var(--color-cyan-700)",
            "decoration-color-cyan-800": "var(--color-cyan-800)",
            "decoration-color-cyan-900": "var(--color-cyan-900)",
            "decoration-color-sky-50": "var(--color-sky-50)",
            "decoration-color-sky-100": "var(--color-sky-100)",
            "decoration-color-sky-200": "var(--color-sky-200)",
            "decoration-color-sky-300": "var(--color-sky-300)",
            "decoration-color-sky-400": "var(--color-sky-400)",
            "decoration-color-sky-500": "var(--color-sky-500)",
            "decoration-color-sky-600": "var(--color-sky-600)",
            "decoration-color-sky-700": "var(--color-sky-700)",
            "decoration-color-sky-800": "var(--color-sky-800)",
            "decoration-color-sky-900": "var(--color-sky-900)",
            "decoration-color-blue-50": "var(--color-blue-50)",
            "decoration-color-blue-100": "var(--color-blue-100)",
            "decoration-color-blue-200": "var(--color-blue-200)",
            "decoration-color-blue-300": "var(--color-blue-300)",
            "decoration-color-blue-400": "var(--color-blue-400)",
            "decoration-color-blue-500": "var(--color-blue-500)",
            "decoration-color-blue-600": "var(--color-blue-600)",
            "decoration-color-blue-700": "var(--color-blue-700)",
            "decoration-color-blue-800": "var(--color-blue-800)",
            "decoration-color-blue-900": "var(--color-blue-900)",
            "decoration-color-indigo-50": "var(--color-indigo-50)",
            "decoration-color-indigo-100": "var(--color-indigo-100)",
            "decoration-color-indigo-200": "var(--color-indigo-200)",
            "decoration-color-indigo-300": "var(--color-indigo-300)",
            "decoration-color-indigo-400": "var(--color-indigo-400)",
            "decoration-color-indigo-500": "var(--color-indigo-500)",
            "decoration-color-indigo-600": "var(--color-indigo-600)",
            "decoration-color-indigo-700": "var(--color-indigo-700)",
            "decoration-color-indigo-800": "var(--color-indigo-800)",
            "decoration-color-indigo-900": "var(--color-indigo-900)",
            "decoration-color-violet-50": "var(--color-violet-50)",
            "decoration-color-violet-100": "var(--color-violet-100)",
            "decoration-color-violet-200": "var(--color-violet-200)",
            "decoration-color-violet-300": "var(--color-violet-300)",
            "decoration-color-violet-400": "var(--color-violet-400)",
            "decoration-color-violet-500": "var(--color-violet-500)",
            "decoration-color-violet-600": "var(--color-violet-600)",
            "decoration-color-violet-700": "var(--color-violet-700)",
            "decoration-color-violet-800": "var(--color-violet-800)",
            "decoration-color-violet-900": "var(--color-violet-900)",
            "decoration-color-purple-50": "var(--color-purple-50)",
            "decoration-color-purple-100": "var(--color-purple-100)",
            "decoration-color-purple-200": "var(--color-purple-200)",
            "decoration-color-purple-300": "var(--color-purple-300)",
            "decoration-color-purple-400": "var(--color-purple-400)",
            "decoration-color-purple-500": "var(--color-purple-500)",
            "decoration-color-purple-600": "var(--color-purple-600)",
            "decoration-color-purple-700": "var(--color-purple-700)",
            "decoration-color-purple-800": "var(--color-purple-800)",
            "decoration-color-purple-900": "var(--color-purple-900)",
            "decoration-color-fuchsia-50": "var(--color-fuchsia-50)",
            "decoration-color-fuchsia-100": "var(--color-fuchsia-100)",
            "decoration-color-fuchsia-200": "var(--color-fuchsia-200)",
            "decoration-color-fuchsia-300": "var(--color-fuchsia-300)",
            "decoration-color-fuchsia-400": "var(--color-fuchsia-400)",
            "decoration-color-fuchsia-500": "var(--color-fuchsia-500)",
            "decoration-color-fuchsia-600": "var(--color-fuchsia-600)",
            "decoration-color-fuchsia-700": "var(--color-fuchsia-700)",
            "decoration-color-fuchsia-800": "var(--color-fuchsia-800)",
            "decoration-color-fuchsia-900": "var(--color-fuchsia-900)",
            "decoration-color-pink-50": "var(--color-pink-50)",
            "decoration-color-pink-100": "var(--color-pink-100)",
            "decoration-color-pink-200": "var(--color-pink-200)",
            "decoration-color-pink-300": "var(--color-pink-300)",
            "decoration-color-pink-400": "var(--color-pink-400)",
            "decoration-color-pink-500": "var(--color-pink-500)",
            "decoration-color-pink-600": "var(--color-pink-600)",
            "decoration-color-pink-700": "var(--color-pink-700)",
            "decoration-color-pink-800": "var(--color-pink-800)",
            "decoration-color-pink-900": "var(--color-pink-900)",
            "decoration-color-rose-50": "var(--color-rose-50)",
            "decoration-color-rose-100": "var(--color-rose-100)",
            "decoration-color-rose-200": "var(--color-rose-200)",
            "decoration-color-rose-300": "var(--color-rose-300)",
            "decoration-color-rose-400": "var(--color-rose-400)",
            "decoration-color-rose-500": "var(--color-rose-500)",
            "decoration-color-rose-600": "var(--color-rose-600)",
            "decoration-color-rose-700": "var(--color-rose-700)",
            "decoration-color-rose-800": "var(--color-rose-800)",
            "decoration-color-rose-900": "var(--color-rose-900)",
            "decoration-color-slate-50": "var(--color-slate-50)",
            "decoration-color-slate-100": "var(--color-slate-100)",
            "decoration-color-slate-200": "var(--color-slate-200)",
            "decoration-color-slate-300": "var(--color-slate-300)",
            "decoration-color-slate-400": "var(--color-slate-400)",
            "decoration-color-slate-500": "var(--color-slate-500)",
            "decoration-color-slate-600": "var(--color-slate-600)",
            "decoration-color-slate-700": "var(--color-slate-700)",
            "decoration-color-slate-800": "var(--color-slate-800)",
            "decoration-color-slate-900": "var(--color-slate-900)",
            "decoration-color-gray-50": "var(--color-gray-50)",
            "decoration-color-gray-100": "var(--color-gray-100)",
            "decoration-color-gray-200": "var(--color-gray-200)",
            "decoration-color-gray-300": "var(--color-gray-300)",
            "decoration-color-gray-400": "var(--color-gray-400)",
            "decoration-color-gray-500": "var(--color-gray-500)",
            "decoration-color-gray-600": "var(--color-gray-600)",
            "decoration-color-gray-700": "var(--color-gray-700)",
            "decoration-color-gray-800": "var(--color-gray-800)",
            "decoration-color-gray-900": "var(--color-gray-900)",
            "decoration-color-zinc-50": "var(--color-zinc-50)",
            "decoration-color-zinc-100": "var(--color-zinc-100)",
            "decoration-color-zinc-200": "var(--color-zinc-200)",
            "decoration-color-zinc-300": "var(--color-zinc-300)",
            "decoration-color-zinc-400": "var(--color-zinc-400)",
            "decoration-color-zinc-500": "var(--color-zinc-500)",
            "decoration-color-zinc-600": "var(--color-zinc-600)",
            "decoration-color-zinc-700": "var(--color-zinc-700)",
            "decoration-color-zinc-800": "var(--color-zinc-800)",
            "decoration-color-zinc-900": "var(--color-zinc-900)",
            "decoration-color-neutral-50": "var(--color-neutral-50)",
            "decoration-color-neutral-100": "var(--color-neutral-100)",
            "decoration-color-neutral-200": "var(--color-neutral-200)",
            "decoration-color-neutral-300": "var(--color-neutral-300)",
            "decoration-color-neutral-400": "var(--color-neutral-400)",
            "decoration-color-neutral-500": "var(--color-neutral-500)",
            "decoration-color-neutral-600": "var(--color-neutral-600)",
            "decoration-color-neutral-700": "var(--color-neutral-700)",
            "decoration-color-neutral-800": "var(--color-neutral-800)",
            "decoration-color-neutral-900": "var(--color-neutral-900)",
            "decoration-color-stone-50": "var(--color-stone-50)",
            "decoration-color-stone-100": "var(--color-stone-100)",
            "decoration-color-stone-200": "var(--color-stone-200)",
            "decoration-color-stone-300": "var(--color-stone-300)",
            "decoration-color-stone-400": "var(--color-stone-400)",
            "decoration-color-stone-500": "var(--color-stone-500)",
            "decoration-color-stone-600": "var(--color-stone-600)",
            "decoration-color-stone-700": "var(--color-stone-700)",
            "decoration-color-stone-800": "var(--color-stone-800)",
            "decoration-color-stone-900": "var(--color-stone-900)"
        }
    },
    exampleData: [
        {
            example: {
                code: `
<p class="underline decoration-blue-500">This text has a blue underline.</p>
<p class="line-through decoration-gray-400">This text has a gray line-through.</p>
<p class="overline decoration-red-600">This text has a red overline.</p>
<p class="underline decoration-inherit">This underline uses inherit.</p>
<p class="underline decoration-current">This underline uses currentColor.</p>
<p class="underline decoration-transparent">This underline is transparent.</p>
        `
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">decoration-*</code> utilities to control the color of text decoration lines. Supports palette colors, <code>inherit</code>, <code>currentColor</code>, and <code>transparent</code>.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-blue-500</small>
          <p class="underline decoration-blue-500 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-gray-400</small>
          <p class="line-through decoration-gray-400 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-red-600</small>
          <p class="overline decoration-red-600 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-orange-600/50</small>
          <p class="underline decoration-orange-600/50 text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-current</small>
          <p class="underline decoration-current text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">decoration-[#7ccf00] dark:decoration-[#ecfcca]</small>
          <p class="underline decoration-[#7ccf00] dark:decoration-[#ecfcca] text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
        }
    ]
};

export default textDecorationColor;
<div className="decoration-blue-500 decoration-[#7ccf00] dark:decoration-[#ecfcca] decoration-gray-400 decoration-red-600 decoration-current decoration-orange-600/50"></div>